var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group 12427"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M16.2839 15.0996C14.9412 15.0996 13.834 16.1832 13.834 17.5496C13.834 18.8923 14.9176 19.9995 16.2839 19.9995C17.6267 19.9995 18.7339 18.9159 18.7339 17.5496C18.7104 16.2068 17.6267 15.0996 16.2839 15.0996Z",
  fill: "#DC362E"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M20.595 3.41581C20.5479 3.41581 20.4772 3.39226 20.4065 3.39226H5.56542L5.32985 1.81391C5.18851 0.777392 4.29333 0 3.23325 0H1.32511C0.806844 0 0.382812 0.424032 0.382812 0.942293C0.382812 1.46055 0.806844 1.88459 1.32511 1.88459H3.23325C3.35104 1.88459 3.44526 1.97882 3.46882 2.0966L4.92938 12.0378C5.11784 13.2863 6.20147 14.2286 7.47357 14.2286H17.2734C18.4984 14.2286 19.5585 13.357 19.8176 12.1556L21.3488 4.49945C21.4431 4.00475 21.1133 3.51004 20.595 3.41581Z",
  fill: "#DC362E"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_5"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_6"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M10.2778 17.4318C10.2307 16.1361 9.14707 15.0996 7.85142 15.0996C6.48509 15.1703 5.44857 16.301 5.49568 17.6438C5.5428 18.9395 6.60288 19.976 7.89853 19.976H7.94565C9.28841 19.9053 10.3485 18.7746 10.2778 17.4318Z",
  fill: "#DC362E"
}))));

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.ecaad39e.svg";
export { ForwardRef as ReactComponent };